import { AbstractControl, FormArray, FormControl, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";

export function timeValidator2(): ValidatorFn {
  return (formArray: AbstractControl): ValidationErrors | null => {
    if (!(formArray instanceof FormArray)) {
      return null; // Ensure it's a FormArray
    }

    let error : any = null;

    const controls = formArray.controls as FormGroup[];
    const times = controls.map(group => ({
      from: group.get('fromTime')?.value,
      to: group.get('toTime')?.value || '00:00', // Default to midnight if null
      fromControl: group.get('fromTime') as FormControl,
      toControl: group.get('toTime')  as FormControl
    }));

    controls.forEach(group => {
      clearErrors(group.get('fromTime') as FormControl);
      clearErrors(group.get('toTime') as FormControl);
    });
    
    let hasOvernightShift = false; // Track if one shift crosses midnight
    
    for (let i = 0; i < times.length; i++) {
      const current = times[i];
      const currentFrom = convertToMinutes(current.from);
      let currentTo = convertToMinutes(current.to);
      const crossesMidnight = currentFrom > currentTo;

      if (crossesMidnight) {
        if (hasOvernightShift) {
          // If another shift already crossed midnight, return error
          addMultipleOvernightShiftsError(current.fromControl);
          addMultipleOvernightShiftsError(current.toControl);

          // Validation 1: Ensure 'from' is before 'to', unless it crosses midnight
          if (currentFrom >= currentTo && currentTo !== 0) {
            addInvalidTimeRangeError(current.fromControl);
            addInvalidTimeRangeError(current.toControl);
          }
        
        }
        hasOvernightShift = true; // Mark this as the allowed overnight shift
      } else {
        // Validation 1: Ensure 'from' is before 'to', unless it crosses midnight
        if (currentFrom >= currentTo && currentTo !== 0) {
          addInvalidTimeRangeError(current.fromControl);
          addInvalidTimeRangeError(current.toControl);
        }
      }




      // Validation 2: Check for overlapping time slots
      for (let j = i + 1; j < times.length; j++) {
        const next = times[j];
        let nextFrom = convertToMinutes(next.from);
        let nextTo = convertToMinutes(next.to);
        
        if (currentFrom > currentTo) {
          currentTo = currentTo + 1440;
        }

        if (nextFrom > nextTo) {
          nextTo = nextTo + 1440;
        }

        if (isOverlapping(currentFrom, currentTo, nextFrom, nextTo)) {
          addOverlappingTimesError(current.fromControl, current.toControl, formArray);
          addOverlappingTimesError(next.fromControl, next.toControl, formArray);
          error = { overlappingTimes: true };
        }
      }

      current.fromControl.markAsTouched();
      current.toControl.markAsTouched();
    }

    return error; // Valid form
  };
}

// Convert HH:mm to total minutes
function convertToMinutes(time: number): number {
  // if (!time) return 0;
  // const [hours, minutes] = time.split(':').map(Number);
  // return hours * 60 + minutes;

  return time;
}

// Check if two time slots overlap
function isOverlapping(from1: number, to1: number, from2: number, to2: number): boolean {
  //return (from1 < to2 && to1 > from2) || (to1 === 0 && from1 < from2); // Allows next-day shift
  return (from1 >= from2 && from1 < to2) ||
         (to1 > from2 && to1 <= to2) ||
         (from1 <= from2 && to1 >= to2) ||
         (to1 >= 1440 && (from2 + 1440) <= to1);
}

function addInvalidTimeRangeError(control : FormControl) {
  control?.setErrors({ ...control?.errors, invalidTimeRange: true });
  control.markAsTouched();
}

function addMultipleOvernightShiftsError(control : FormControl) {
  control?.setErrors({ ...control?.errors, multipleOvernightShifts: true });
  control.markAsTouched();
}

function addOverlappingTimesError(from : FormControl, to : FormControl, formArrayControl : FormArray) {
  from?.setErrors({ ...from?.errors, overlappingTimes: true });
  to?.setErrors({ ...to?.errors, overlappingTimes: true });

  from.markAsTouched();
  to.markAsTouched();
}


function clearErrors(control : FormControl) {
  removeInvalidTimeRangeError(control);
  removeOverlappingTimesError(control);
  removeMultipleOvernightShitsError(control);
}

function removeInvalidTimeRangeError(control : FormControl) {
  const currentErrorsFrom = control?.errors;

  if (currentErrorsFrom) {
    const { invalidTimeRange, ...remainingErrors } = currentErrorsFrom;
    control?.setErrors(Object.keys(remainingErrors).length ? remainingErrors : null);
  }

  control.markAsTouched();
}

function removeOverlappingTimesError(control : FormControl) {
  const currentErrorsFrom = control?.errors;

  if (currentErrorsFrom) {
    const { overlappingTimes, ...remainingErrors } = currentErrorsFrom;
    control?.setErrors(Object.keys(remainingErrors).length ? remainingErrors : null);
  }

  control.markAsTouched();
}

function removeMultipleOvernightShitsError(control : FormControl) {
  const currentErrorsFrom = control?.errors;

  if (currentErrorsFrom) {
    const { multipleOvernightShifts, ...remainingErrors } = currentErrorsFrom;
    control?.setErrors(Object.keys(remainingErrors).length ? remainingErrors : null);
  }

  control.markAsTouched();
}
